/* eslint-disable */
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../../Components/ui/tabs'
import { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import MFBasketsInvestments from '../MutualFundsBaskets/MFBasketsInvestments'
import MFIndividualInvestments from './MFIndividualInvestments'
import PostHogTracker from '../../utils/PostHogTracker'
import MFNonFabitsAssets from './MFNonFabitsAssets'
import { useRecoilValueLoadable } from 'recoil'
import { MutualFundsHolding } from '../../store/MFStore'

const MFInvestments = () => {
  const location = useLocation()
  const mfHolding = useRecoilValueLoadable(MutualFundsHolding)
  const filteredHoldings =
    mfHolding?.contents?.mainData?.filter(
      (item) => item?.isOutsideData === 1 && Number(item?.balance) > 0 && item?.isincd,
    ) || []

  const [tabValue, setTabValue] = useState(location.state?.tab || 'Goals')

  useEffect(() => {
    // Track holdings page viewed
    PostHogTracker.holdingsTabClicked()
    PostHogTracker.pageViewed('My Portfolio - Holdings')
  }, [])

  useEffect(() => {
    if (location.state?.tab) {
      setTabValue(location.state.tab)
    }
  }, [location.state?.tab])

  return (
    <>
      <div className='mx-auto max-w-[1128px]'>
        <h2 className='px-4 pb-3 pt-4 font-IBM text-lg font-semibold leading-6 text-black-950 lg:px-0 lg:text-xl'>
          My Portfolio
        </h2>
      </div>

      <div className='mx-auto max-w-[1128px]'>
        <Tabs value={tabValue} onValueChange={setTabValue} className='relative mr-auto w-full'>
          <div className='px-4 lg:px-0'>
            <TabsList className='mx-auto grid h-12 max-w-[520px] rounded-full [grid-template-columns:repeat(auto-fit,minmax(0,1fr))]'>
              <TabsTrigger value='Goals' className='relative h-10 px-2 text-sm leading-5 md:px-4'>
                Goals
              </TabsTrigger>

              <TabsTrigger
                value='Mutual Funds'
                className='relative h-10 px-2 text-sm leading-5 md:px-4'
              >
                <span className='sm:hidden'>Funds</span>
                <span className='hidden sm:inline'>Mutual Funds</span>
              </TabsTrigger>

              {filteredHoldings.length > 0 && (
                <TabsTrigger
                  value='Non Fabits Assets'
                  className='relative h-10 px-2 text-sm leading-5 md:px-4'
                >
                  <span className='sm:hidden'>External</span>
                  <span className='hidden sm:inline'>Non Fabits Assets</span>
                </TabsTrigger>
              )}
            </TabsList>
          </div>

          <TabsContent value='Goals'>
            <MFBasketsInvestments emptyStateVariant='goals' />
          </TabsContent>

          <TabsContent value='Mutual Funds'>
            <MFIndividualInvestments emptyStateVariant='funds' />
          </TabsContent>
          {filteredHoldings.length > 0 && (
            <TabsContent value='Non Fabits Assets'>
              <MFNonFabitsAssets emptyStateVariant='external' />
            </TabsContent>
          )}
        </Tabs>
      </div>
    </>
  )
}

export default MFInvestments
